import React from "react";
import { observer } from "mobx-react";
import { hiddenContentCheck } from "../Helpers/General/HiddenContentHelper";
var classNames = require('classnames');

const SurveyConditionalSegment = observer((props) => {
    let hiddenTrigger = hiddenContentCheck(props);

    if (hiddenTrigger) return (null)
    return (
        <div className={classNames("fade-in")}>
            {props.children}
        </div>
    ); 
    
});
export default SurveyConditionalSegment;
